import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { useMount } from 'ahooks';
import { useRef } from 'react';
import css from './index.module.scss';
type iconItem = {
    icon: string; // icon路径
    device: string; // 设备名称
    usageTime: {
        time: number | string; //时间
        unit: string; // 单位
        port?: string; //端口
    }[];
};

type item = {
    key: number;
    title: string; //tab标题
    content: iconItem[]; // 内容
};

type params = {
    data: {
        title1: string; // 第一行标题
        title2: string; // 第二行标题
        list: item[]; // list内容
    };
    config?: any;
    langKey?: string;
};

export default function SwitchTabIcon({ data, config, langKey = 'product' }: params) {
    const { useState, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [currentIndex, setCurrentIndex] = useState(0);
    const { t } = useLang(langKey);

    const boxRef = useRef<HTMLUListElement>(null);

    const mapSize = {
        es: 417,
        it: 228,
        fr: 455,
        jp: 237,
        de: 333,
        cn: 158,
    };
    type Asmapsize = keyof typeof mapSize;
    const [tabPosition, setTabPosition] = useState({
        tabWidth: mapSize[locale as Asmapsize] || 170,
        offsetLeft: 0,
    });

    const handleChangeTab = (key: number, event: any) => {
        const dom = event.target;
        setTab(key, dom);
    };

    const setTab = (key: number, target: any) => {
        const { clientWidth, offsetLeft } = target;
        setTabPosition({ tabWidth: clientWidth, offsetLeft });
        setCurrentIndex(key);
    };

    useMount(() => {
        try {
            if (boxRef.current) {
                setTab(0, boxRef.current.childNodes[0]);
            }
        } catch (e) {}
    });

    return (
        <div className={css.switch_tab_icon}>
            <div className="container">
                <div className="head font-family-bold">
                    <div className="l1">{data.title1}</div>
                    <div className="l2">{data.title2}</div>
                </div>
                <div className="tab">
                    <ul ref={boxRef}>
                        {data.list?.map((item) => (
                            <li
                                key={item.key}
                                className={`menuItem font-family-semibold ${currentIndex === item.key ? 'active' : ''}`}
                                onClick={(e) => handleChangeTab(item.key, e)}
                            >
                                {item.title}
                            </li>
                        ))}
                    </ul>
                    <div
                        className="line"
                        style={{
                            left: `${tabPosition.offsetLeft}px`,
                            width: `${tabPosition.tabWidth}px`,
                        }}
                    />
                </div>
                <ul className="content">
                    {data.list
                        ?.find((item) => item.key === currentIndex)
                        ?.content.map((item, index) => (
                            <li className="item" key={index}>
                                <Image src={item.icon} width={96} height={96} alt={t(item.device)} />
                                <p className="device font-family-regular">{t(item.device)}</p>
                                <ul className="usageTime ">
                                    {item.usageTime?.map((usageTimeItem, index) => (
                                        <li className="usageTimeItem font-family-bold" key={index}>
                                            <p>
                                                <strong className="time">{usageTimeItem.time}</strong>
                                                <span className="unit">&nbsp; &nbsp;{usageTimeItem.unit}</span>
                                            </p>
                                            <p className="port">{usageTimeItem.port}</p>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    );
}
